export { default } from './multi-selection';
